import Action from './Action';
import * as ActionMethods from './ActionMethods';
import BillingAccountService from '../services/BillingAccountService';
import LocalStorageService from '../services/LocalStorageService';
import EventDispatcher from "../framework/EventDispatcher";
import ApplicationStore from '../framework/ApplicationStore';
import Error from '../model/Error';

export const CALENDER_INFO = "CALENDER_INFO"


export default function reducer (state ={}, action={}){
	switch (action.type) {
		case EventDispatcher.successAction(CALENDER_INFO):
			return {
				...state,
				calendar: action.data.calendar
			};
			break;
			default:
			return state;
		}
	}


export function fetchMyNextInvoiceDate() {
	const action = new Action(ActionMethods.FETCH_BILLINGACCOUNT, function() {
		const { customerAccount } = LocalStorageService.getCurrentCustomer();
		const { billingAccount } = customerAccount;

		BillingAccountService.getNextInvoiceDate(billingAccount).then(accountlist => {
			const { actionStatus } = accountlist;
			if(actionStatus == null || actionStatus.status === "FAIL") {
				this.fail(actionStatus);
			} else {
				const {billingAccount={}}  = accountlist;
				this.success(billingAccount.nextInvoiceDate);
			}
		}).catch(error => {
			this.fail(error);
		});
	});

	const currentCustomer = LocalStorageService.getCurrentCustomer();
	if(currentCustomer == null){
		const {messages: mainMessages={}} = ApplicationStore.getState();
		const {messages = {}} = mainMessages || {};
		action.fail(new Error({ message: messages["common.error.customer.not.connected"] }));
	}

	action.execute(currentCustomer);
}

export function fetchCalendarInfo(billingCycleCode) {
return dispatch => {
	EventDispatcher.loading(dispatch, CALENDER_INFO);
	BillingAccountService.getBillingCycle(billingCycleCode)
	.then(response => {
		if (response === null || response.status === "FAIL") {
			throw response;
		} else {
			const {billingCycle} = response;
			BillingAccountService.getCalendar(billingCycle.calendar)
			.then(response => {
				if (response === null || response.status === "FAIL") {
					throw response;
				} else {
					const {calendar} = response;
					EventDispatcher.success(dispatch, CALENDER_INFO, {calendar});
			}})
			.catch(error =>{
					EventDispatcher.error(dispatch, CALENDER_INFO, {error})
			})}
			})
			.catch(error =>{
					EventDispatcher.error(dispatch, CALENDER_INFO, {error})
			})

}}



// WEBPACK FOOTER //
// ./src/opencell/actions/BillingAccountActions.js